const defaultPlaneReducer = (state = [], action) => {
     switch (action.type) {
         case 'EDIT_PLANE':
             return action.data;
         default:
             return state;
     }
 }
 export default defaultPlaneReducer;
 
